import { surveyManagementFeature } from './survey-management.feature';

export const {
  selectBuyerProjectManagerUpdating,
  selectOperatorProjectManagerUpdating,
  selectError,
  selectCreatingPriceBlock,
  selectPriceBlockError,
  selectResettingFusionBlockStats,
  selectFusionBlockResetError,
  selectFusionStats,
  selectFusionStatsLoading,
  selectFusionStatsError,
  selectSurveyManagementState,
} = surveyManagementFeature;
